import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    
    // /**************************************************************
    // -> Pageload animation
    // **************************************************************/
    function pageTaxoDestinationsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-taxonomy-destinations .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-taxonomy-destinations .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-taxonomy-destinations .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
    }
    pageTaxoDestinationsLoadAnimation()

    /**************************************************************
    -> Taxonomy Type intro anim on scroll
    **************************************************************/
    function inViewAnimIntroTaxoType() {
      gsap.fromTo('.intro-taxonomy-destinations-landing .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-taxonomy-destinations-landing .intro-container',
      })

      gsap.fromTo('.intro-taxonomy-destinations-landing .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-taxonomy-destinations-landing .intro-container',
      })

    }
    inViewAnimIntroTaxoType();

    /**************************************************************
    -> Taxonomy Type intro anim on scroll
    **************************************************************/
    function inViewAnimFiltersTaxoType() {
      gsap.fromTo('.filters-taxonomy-destinations-landing .filter-title' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.filters-taxonomy-destinations-landing .filter-title',
      })

      gsap.fromTo('.filters-taxonomy-destinations-landing .wrap-sort-buttons' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.filters-taxonomy-destinations-landing .wrap-sort-buttons',
      })
    }
    inViewAnimFiltersTaxoType();

    /**************************************************************
    -> Experiences List anim on scroll
    **************************************************************/
    function inViewAnimListExperiencesTaxoType() {
      gsap.fromTo('.experiences-list-destinations-taxonomy .wrap-experiences-list .experience-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.experiences-list-type-taxonomy .wrap-experiences-list',
      })

    }
    inViewAnimListExperiencesTaxoType();


    $(document).on('facetwp-refresh', function() {
      const buttonAll = document.querySelector('.sort-all');  
      const otherSortButton = Array.from(document.querySelectorAll('.facetwp-checkbox'));
    

      buttonAll.addEventListener('click', () => {
        buttonAll.classList.add('active');
      })

      otherSortButton.forEach(button => {

        button.addEventListener('click', () => {
          buttonAll.classList.remove('active');
        })

        if(button.classList.contains('checked')) {
          buttonAll.classList.remove('active');
        }
      })


      // /**************************************************************
      // -> Clear Subfilter if Main filter is reset or refilter
      // **************************************************************/
      // // eslint-disable-next-line no-undef
      // if (FWP.facets['sort_by_type'].length === 0) {
      //   // eslint-disable-next-line no-undef
      //   FWP.facets['by_countries'] = [];
      // }
    })


    /**************************************************************
    -> Show hide sub filter if first filter has a choice
    **************************************************************/
  //  $(document).on('facetwp-loaded', function() {
  //   const countriesSubFilter = document.querySelector('.sub-sorting-by-countries');
  //   // eslint-disable-next-line no-undef
  //   if (FWP) {
  //     // eslint-disable-next-line no-undef
  //     if (FWP.facets.sort_by_type.length === 0) {
  //       countriesSubFilter.classList.remove('active')
  //     } else {
  //       countriesSubFilter.classList.add('active')
  //     }
  //   }
  // });

    // eslint-disable-next-line no-undef
    FWP.loading_handler = function() { }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/destinations-data.js